import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4 overflow-auto h-auto font-inter" }
const _hoisted_2 = { class: "pb-5" }
const _hoisted_3 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  style: {"background":"#F5F5F5"},
  class: "flex items-center gap-4 rounded-xl mb-4 p-2"
}
const _hoisted_7 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"min-width":"24px"},
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "#575757",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 8V12",
  stroke: "#575757",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 16H12.01",
  stroke: "#575757",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Faça solicitações com moderação!", -1)
const _hoisted_13 = { class: "flex flex-col gap-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-4 items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "21",
    height: "32",
    viewBox: "0 0 21 32",
    fill: "#292f31",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M17.5731 11.1831L13.3962 10.341L13.3964 0.875729C13.3964 0.404162 12.9923 0 12.5207 0H7.63629C7.16473 0 6.76057 0.404138 6.76057 0.875729V10.3747L2.58366 11.2168C0.933077 11.5537 -0.178562 13.103 0.0237233 14.7537L1.87642 29.5747C2.04488 30.9559 3.22366 32 4.60477 32H15.5185C16.8996 32 18.0784 30.9559 18.2468 29.5747L20.0995 14.7537C20.3352 13.0695 19.19 11.5199 17.573 11.1832L17.5731 11.1831ZM11.6112 1.75152V3.60421H8.47865L8.47841 1.75152H11.6112ZM18.3817 14.5178L16.529 29.3389C16.4616 29.8441 16.0238 30.2146 15.5184 30.2146L4.60472 30.2148C4.09955 30.2148 3.66156 29.8443 3.59413 29.3391L1.74144 14.5181C1.64041 13.777 2.14558 13.0359 2.92051 12.9013L7.80466 11.9579C8.2088 11.8905 8.51215 11.5199 8.51215 11.1158V5.38953H11.6447V11.1158C11.6447 11.5199 11.9478 11.8905 12.3521 11.9579L17.2363 12.9346C17.9774 13.0695 18.4826 13.7767 18.3815 14.5178L18.3817 14.5178Z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M15.3189 14.7869L15.1504 14.7533C11.782 14.0796 8.37991 14.0796 4.9778 14.7533L4.84317 14.7869C4.4052 14.8879 4.10212 15.292 4.16955 15.7636L5.1127 23.2752C5.18014 23.7131 5.55067 24.0498 5.98843 24.0498H14.2411C14.679 24.0498 15.0495 23.7129 15.1168 23.2752L16.06 15.7636C16.0602 15.3259 15.7571 14.8879 15.3191 14.7869H15.3189ZM13.399 22.2984H6.72955L5.9885 16.3701C8.71686 15.8985 11.4453 15.8985 14.1738 16.3701L13.399 22.2984Z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M13.6662 26.2734H6.45776C5.98619 26.2734 5.58203 26.6776 5.58203 27.1492C5.58203 27.6208 5.98617 28.0249 6.45776 28.0249H13.6999C14.1714 28.0249 14.5756 27.6208 14.5756 27.1492C14.5422 26.6776 14.1717 26.2734 13.6665 26.2734H13.6662Z" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-start" }, "Pedir molhos"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Peça molhos para sua mesa")
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,105.14a1.085,1.085,0,0,1-.743-.288L.308,98.818a.939.939,0,0,1,0-1.39,1.1,1.1,0,0,1,1.486,0l5.707,5.34,5.707-5.339a1.1,1.1,0,0,1,1.485,0,.938.938,0,0,1,0,1.39l-6.45,6.035A1.085,1.085,0,0,1,7.5,105.14Z",
  transform: "translate(-0.001 -97.14)"
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "flex flex-col gap-4 overflow-hidden" }
const _hoisted_18 = { class: "flex justify-between items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Ketchup")
  ])
], -1)
const _hoisted_20 = { class: "flex gap-4 items-center" }
const _hoisted_21 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H5V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "flex items-center justify-between" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Maionese")
  ])
], -1)
const _hoisted_29 = { class: "flex gap-4 items-center" }
const _hoisted_30 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("path", { d: "M19,13H5V11H19V13Z" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "flex items-center justify-between" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Maionese temperada")
  ])
], -1)
const _hoisted_38 = { class: "flex gap-4 items-center" }
const _hoisted_39 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H5V11H19V13Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "flex gap-4 items-center" }
const _hoisted_46 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11,9H9V2H7V9H5V2H3V9C3,11.12 4.66,12.84 6.75,12.97V22H9.25V12.97C11.34,12.84 13,11.12 13,9V2H11V9M16,6V14H18.5V22H21V2C18.24,2 16,4.24 16,6Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-start" }, "Pedir utensílios"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Um garçom trará utensílios para você")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,105.14a1.085,1.085,0,0,1-.743-.288L.308,98.818a.939.939,0,0,1,0-1.39,1.1,1.1,0,0,1,1.486,0l5.707,5.34,5.707-5.339a1.1,1.1,0,0,1,1.485,0,.938.938,0,0,1,0,1.39l-6.45,6.035A1.085,1.085,0,0,1,7.5,105.14Z",
  transform: "translate(-0.001 -97.14)"
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "flex flex-col gap-4 overflow-hidden" }
const _hoisted_53 = { class: "flex justify-between items-center" }
const _hoisted_54 = { class: "flex items-center gap-4" }
const _hoisted_55 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.12,21.29L3.71,19.88L13.36,10.22L13.16,10C12.38,9.23 12.38,7.97 13.16,7.19L17.5,2.82L18.43,3.74L15.19,7L16.15,7.94L19.39,4.69L20.31,5.61L17.06,8.85L18,9.81L21.26,6.56L22.18,7.5L17.81,11.84C17.03,12.62 15.77,12.62 15,11.84L14.78,11.64L5.12,21.29Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Garfo")
], -1)
const _hoisted_59 = { class: "flex gap-4 items-center" }
const _hoisted_60 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H5V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { class: "flex justify-between items-center" }
const _hoisted_67 = { class: "flex items-center gap-4" }
const _hoisted_68 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.88,11.53L5.12,21.29L3.71,19.88L13.47,10.12C12.76,8.59 13.26,6.44 14.85,4.85C16.76,2.93 19.5,2.57 20.96,4.03C22.43,5.5 22.07,8.24 20.15,10.15C18.56,11.74 16.41,12.24 14.88,11.53Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Colher")
], -1)
const _hoisted_72 = { class: "flex gap-4 items-center" }
const _hoisted_73 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H5V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { class: "flex justify-between items-center" }
const _hoisted_80 = { class: "flex items-center gap-4" }
const _hoisted_81 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20.62,2C23.97,7.61 12.47,20.15 12.47,20.15L9.6,17.28L4.91,22L2.77,19.86L20.62,2Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Faca")
], -1)
const _hoisted_85 = { class: "flex gap-4 items-center" }
const _hoisted_86 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H5V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = { class: "flex items-center justify-between" }
const _hoisted_93 = { class: "flex items-center gap-4" }
const _hoisted_94 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.88 4L16.88 4L19.03 6.1L13.5 10.5L12.5 9.5L16.87 4L16.88 4M16.88 2C16.3 2 15.73 2.24 15.33 2.72L9.8 9.65L13.34 13.19L20.28 7.67C21.18 6.91 21.25 5.54 20.41 4.7L18.3 2.59C17.9 2.19 17.39 2 16.88 2M9.1 10.36L8.39 11.07C8 11.46 8 12.09 8.39 12.5L10.5 14.6C10.71 14.8 10.96 14.89 11.22 14.89S11.73 14.8 11.93 14.6L12.63 13.9L9.1 10.36M6 15C5.45 15 5 15.45 5 16C5 16.55 5.45 17 6 17C6.55 17 7 16.55 7 16C7 15.45 6.55 15 6 15M9 16C8.45 16 8 16.45 8 17S8.45 18 9 18C9.55 18 10 17.55 10 17S9.55 16 9 16M4 18C3.45 18 3 18.45 3 19S3.45 20 4 20C4.55 20 5 19.55 5 19S4.55 18 4 18M7 19C6.45 19 6 19.45 6 20S6.45 21 7 21C7.55 21 8 20.55 8 20S7.55 19 7 19Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Sal")
], -1)
const _hoisted_98 = { class: "flex items-center justify-between" }
const _hoisted_99 = { class: "flex items-center gap-4" }
const _hoisted_100 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_101 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20,16V4H8V16H20M22,16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20A2,2 0 0,1 22,4V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Guardanapos")
], -1)
const _hoisted_104 = { class: "flex items-center justify-between" }
const _hoisted_105 = { class: "flex items-center gap-4" }
const _hoisted_106 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3 2L5 20.23C5.13 21.23 5.97 22 7 22H17C18 22 18.87 21.23 19 20.23L21 2H3M5.22 4H18.78L17 20H7L5.22 4Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Copo")
], -1)
const _hoisted_110 = { class: "flex gap-4 items-center" }
const _hoisted_111 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H5V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_116 = [
  _hoisted_115
]
const _hoisted_117 = { class: "flex items-center justify-between" }
const _hoisted_118 = { class: "flex items-center gap-4" }
const _hoisted_119 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_120 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Prato")
], -1)
const _hoisted_123 = { class: "flex gap-4 items-center" }
const _hoisted_124 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_125 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H5V11H19V13Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_128 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = { class: "flex gap-4 items-center" }
const _hoisted_131 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"},
  fill: "#292f31"
}
const _hoisted_132 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 3C14.21 3 16 4.79 16 7S14.21 11 12 11 8 9.21 8 7 9.79 3 12 3M16 13.54C16 14.6 15.72 17.07 13.81 19.83L13 15L13.94 13.12C13.32 13.05 12.67 13 12 13S10.68 13.05 10.06 13.12L11 15L10.19 19.83C8.28 17.07 8 14.6 8 13.54C5.61 14.24 4 15.5 4 17V21H20V17C20 15.5 18.4 14.24 16 13.54Z",
  style: {"fill":"#292f31"}
}, null, -1)
const _hoisted_133 = [
  _hoisted_132
]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-start" }, "Chamar garçom"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Envie uma notificação ao garçom")
], -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,105.14a1.085,1.085,0,0,1-.743-.288L.308,98.818a.939.939,0,0,1,0-1.39,1.1,1.1,0,0,1,1.486,0l5.707,5.34,5.707-5.339a1.1,1.1,0,0,1,1.485,0,.938.938,0,0,1,0,1.39l-6.45,6.035A1.085,1.085,0,0,1,7.5,105.14Z",
  transform: "translate(-0.001 -97.14)"
}, null, -1)
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = { class: "overflow-hidden" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-4 items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    stroke: "#292f31",
    fill: "none",
    class: "money"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.5 9.5V14.5M18.5 9.5V14.5M12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-start" }, "Pedir a conta"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Vamos trazer a conta até você")
  ])
], -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,105.14a1.085,1.085,0,0,1-.743-.288L.308,98.818a.939.939,0,0,1,0-1.39,1.1,1.1,0,0,1,1.486,0l5.707,5.34,5.707-5.339a1.1,1.1,0,0,1,1.485,0,.938.938,0,0,1,0,1.39l-6.45,6.035A1.085,1.085,0,0,1,7.5,105.14Z",
  transform: "translate(-0.001 -97.14)"
}, null, -1)
const _hoisted_140 = [
  _hoisted_139
]
const _hoisted_141 = { class: "flex flex-col gap-4 rounded-xl overflow-hidden" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("path", { d: "M12.8786 3.90743V2.23301C12.8786 1.30985 12.1248 0.558594 11.1986 0.558594H4.47859C3.55235 0.558594 2.79859 1.30985 2.79859 2.23301V4.46557H1.67859C1.06091 4.46557 0.558594 4.96622 0.558594 5.58185L0.559714 12.3108L1.09003 21.8298C1.12307 22.4209 1.61419 22.8842 2.20835 22.8842H11.2283C11.823 22.8842 12.3136 22.4209 12.3466 21.8298L12.8786 12.2795V5.58185C12.8786 4.96622 12.3763 4.46557 11.7586 4.46557H10.6386V3.90743H12.8786ZM10.6386 2.23301C10.6386 1.92548 10.8895 1.67487 11.1986 1.67487C11.5077 1.67487 11.7586 1.92548 11.7586 2.23301V2.79115H10.6386V2.23301ZM3.91859 2.23301C3.91859 1.92548 4.16947 1.67487 4.47859 1.67487H9.61435C9.55275 1.84957 9.51859 2.03711 9.51859 2.23301V6.13999H3.91859V2.23301ZM2.20779 21.7679L1.70939 12.8377H11.7267L11.2283 21.7679H2.20779ZM11.7586 5.58185L11.7597 11.7214H1.67859V5.58185H2.79859V7.25627H10.6386V5.58185H11.7586ZM8.39859 18.9772H9.51859V20.0935H8.39859V18.9772ZM6.15859 18.9772H7.27859V20.0935H6.15859V18.9772ZM6.15859 14.5121H7.27859V15.6284H6.15859V14.5121ZM6.15859 16.7446H7.27859V17.8609H6.15859V16.7446ZM8.39859 14.5121H9.51859V15.6284H8.39859V14.5121ZM8.39859 16.7446H9.51859V17.8609H8.39859V16.7446ZM3.91859 18.9772H5.03859V20.0935H3.91859V18.9772ZM3.91859 14.5121H5.03859V15.6284H3.91859V14.5121ZM3.91859 16.7446H5.03859V17.8609H3.91859V16.7446ZM9.51859 8.37255H10.6386V10.6051H9.51859V8.37255Z" }, null, -1)
const _hoisted_143 = [
  _hoisted_142
]
const _hoisted_144 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-start text-gray-500" }, "Pagamento pela maquininha, um garçom será notificado", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3119_239)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17.9361 17.5931C17.4925 17.5946 17.053 17.5083 16.643 17.339C16.233 17.1697 15.8606 16.9209 15.5474 16.6069L12.0968 13.1545C11.9748 13.0378 11.8124 12.9727 11.6436 12.9727C11.4747 12.9727 11.3124 13.0378 11.1904 13.1545L7.72856 16.6163C7.41544 16.9307 7.04313 17.1799 6.63313 17.3496C6.22314 17.5193 5.78359 17.6061 5.33987 17.6049H4.66406L9.03643 21.9773C9.69218 22.6315 10.5807 22.999 11.507 22.999C12.4333 22.999 13.3218 22.6315 13.9776 21.9773L18.3588 17.5954L17.9361 17.5931Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5.34046 5.39248C5.78419 5.39126 6.22376 5.47799 6.63376 5.64768C7.04376 5.81736 7.41607 6.06663 7.72915 6.38107L11.191 9.84408C11.3113 9.96398 11.4743 10.0313 11.6442 10.0313C11.8141 10.0313 11.977 9.96398 12.0974 9.84408L15.5468 6.39467C15.8596 6.07975 16.2318 5.83009 16.6419 5.66018C17.0519 5.49027 17.4916 5.4035 17.9355 5.4049H18.3494L13.9681 1.02366C13.6437 0.699132 13.2586 0.441691 12.8347 0.266048C12.4108 0.0904048 11.9564 0 11.4975 0C11.0387 0 10.5843 0.0904048 10.1604 0.266048C9.73651 0.441691 9.35136 0.699132 9.02697 1.02366L4.66406 5.39248H5.34046Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M21.9765 9.03094L19.3289 6.38328C19.2692 6.40768 19.2054 6.42052 19.1409 6.42112H17.9376C17.3112 6.4227 16.7107 6.67152 16.2667 7.11348L12.8167 10.5641C12.663 10.7178 12.4805 10.8398 12.2796 10.923C12.0788 11.0062 11.8635 11.049 11.6461 11.049C11.4286 11.049 11.2133 11.0062 11.0125 10.923C10.8116 10.8398 10.6291 10.7178 10.4754 10.5641L7.01235 7.10343C6.56848 6.66125 5.96798 6.41221 5.34145 6.41047H3.8633C3.80255 6.40913 3.74251 6.39713 3.68592 6.375L1.02171 9.03567C0.367439 9.69142 0 10.5799 0 11.5062C0 12.4326 0.367439 13.3211 1.02171 13.9768L3.68238 16.6375C3.73885 16.615 3.79896 16.6029 3.85975 16.602H5.34204C5.96856 16.6002 6.56904 16.3512 7.01294 15.9091L10.4748 12.4472C10.7904 12.1463 11.2097 11.9785 11.6458 11.9785C12.0818 11.9785 12.5011 12.1463 12.8167 12.4472L16.2662 15.8961C16.7101 16.338 17.3106 16.5868 17.9371 16.5884H19.1409C19.2054 16.5888 19.2692 16.6017 19.3289 16.6263L21.9765 13.9786C22.3011 13.6542 22.5585 13.2691 22.7342 12.8451C22.9098 12.4212 23.0002 11.9669 23.0002 11.508C23.0002 11.0492 22.9098 10.5948 22.7342 10.1709C22.5585 9.74699 22.3011 9.36183 21.9765 9.03744" })
], -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3119_239" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "23",
      height: "23",
      fill: "white"
    })
  ])
], -1)
const _hoisted_147 = [
  _hoisted_145,
  _hoisted_146
]
const _hoisted_148 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 text-start" }, "Pagamento via pix, enviaremos a chave", -1)
const _hoisted_149 = ["stroke"]
const _hoisted_150 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17 6V16C17 20 16 21 12 21H6C2 21 1 20 1 16V6C1 2 2 1 6 1H12C16 1 17 2 17 6Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11 4.5H7",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.99922 18.1C9.85526 18.1 10.5492 17.406 10.5492 16.55C10.5492 15.694 9.85526 15 8.99922 15C8.14318 15 7.44922 15.694 7.44922 16.55C7.44922 17.406 8.14318 18.1 8.99922 18.1Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_153 = [
  _hoisted_150,
  _hoisted_151,
  _hoisted_152
]
const _hoisted_154 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 text-start" }, "Pagamento online, o garçom será notificado", -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.5 9.5V14.5M18.5 9.5V14.5M12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15Z",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_157 = [
  _hoisted_155,
  _hoisted_156
]
const _hoisted_158 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 text-start" }, "Pague em dinheiro vivo", -1)

import axiosClient from '@/api/axios';
import MyModal from '@/components/modal/MyModal.vue';
import { customer, isAuthModalOpen } from '@/global/state/AuthState';
import { tableNumber, isLoading } from '@/global/state/GlobalState';
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import MySwitch from '@/components/inputs/MySwitch.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerRequestModal',
  props: {
    isCustomerRequestModal: { type: Boolean },
    setIsCustomerRequestModal: { type: Function }
  },
  setup(__props: any) {

const props = __props

const openSections = ref<any>([]);
const selectedBillPaymentMethod = ref<string>('');
const toast = useToast()
const utensils = ref<any>({
    fork: 0,
    spoon: 0,
    knife: 0,
    glass: 0,
    napkin:false,
    salt:false,
    plate: 0,
})
const sauce = ref<any>({
    ketchup: 0,
    mayonnaise: 0,
    seasonedMayonnaise: 0,
})

const toggleSection = (sectionName: string): void => {
  if (openSections.value.includes(sectionName)) {
    openSections.value = openSections.value.filter((section: string) => section !== sectionName);
  } else {
    openSections.value.push(sectionName);
  }
};

function reset(): void{
    sauce.value.ketchup = 0
    sauce.value.mayonnaise = 0
    sauce.value.seasonedMayonnaise = 0
    utensils.value.fork = 0,
    utensils.value.spoon = 0,
    utensils.value.knife = 0,
    utensils.value.glass = 0,
    utensils.value.napkin = false,
    utensils.value.salt = false,
    utensils.value.plate = 0,
    selectedBillPaymentMethod.value = ''
    openSections.value = []
}

function notify(type: string): void{
    if(customer.value.cpf){
        let payload: any = {
            type: type,
            customerCpf: customer.value.cpf,
            customerName: customer.value.name,
            tableNumber: tableNumber.value
        }

        if(customer.value.email) payload.customerEmail = customer.value.email
        if(customer.value.phone) payload.customerPhone = customer.value.phone
    
        if(type == 'order_sauce'){
            payload.ketchupQuantity = sauce.value.ketchup
            payload.mayonnaiseQuantity = sauce.value.mayonnaise
            payload.seasonedMayonnaiseQuantity = sauce.value.seasonedMayonnaise
        }
    
        if(type == 'order_utensils'){
            Object.assign(payload, utensils.value)
        }
    
        if(type == 'order_bill'){
            payload.paymentMethod = selectedBillPaymentMethod.value
        }
    
        isLoading.value = true
        axiosClient.post('/customer/requests', payload).then((res: any) => {
            // A API cria o cadastro do cliente se ainda não existir; com o uuid,
            // o aparelho é registrado para receber a resposta do garçom
            const customerUuid = res.data?.customerUuid
            if(customerUuid && !customer.value.uuid){
                customer.value = { ...customer.value, uuid: customerUuid, is_registered: true }
                localStorage.setItem('customer', JSON.stringify(customer.value))
            }
            reset()
            toast.success('Solicitação enviada')
        }).finally(() => isLoading.value = false)
    } else{
        toast.warning('Faça login para poder fazer uma solicitação', { timeout:2000 })
        props.setIsCustomerRequestModal(false)
        isAuthModalOpen.value = true
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MyModal, {
    id: 'customer-request-modal',
    isOpen: _ctx.isCustomerRequestModal,
    toggleModal: (v) => _ctx.setIsCustomerRequestModal(v),
    height: '31rem',
    zIndex: 150
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "transition duration-200 hover:text-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsCustomerRequestModal(false)))
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_11)),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: _normalizeClass(["border rounded-xl p-4 flex flex-col transition-all duration-200", openSections.value.includes('sauce') ? 'gap-4':'gap-0'])
          }, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSection('sauce'))),
              class: "flex items-center justify-between w-full"
            }, [
              _hoisted_14,
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: _normalizeClass(["transform transition-transform duration-200", openSections.value.includes('sauce') ? 'rotate-180':'rotate-0']),
                width: "15",
                height: "8",
                viewBox: "0 0 15 8",
                stroke: "none"
              }, _hoisted_16, 2))
            ]),
            _createElementVNode("div", {
              class: "grid transition-all duration-200",
              style: _normalizeStyle({gridTemplateRows: openSections.value.includes('sauce') ? '1fr' : '0fr'})
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (sauce.value.ketchup ? sauce.value.ketchup--:'')),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_21, _hoisted_23))
                    ]),
                    _createTextVNode(" " + _toDisplayString(sauce.value.ketchup) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (sauce.value.ketchup++)),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_24, _hoisted_26))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (sauce.value.mayonnaise ? sauce.value.mayonnaise--:'')),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_30, _hoisted_32))
                    ]),
                    _createTextVNode(" " + _toDisplayString(sauce.value.mayonnaise) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (sauce.value.mayonnaise++)),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_33, _hoisted_35))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (sauce.value.seasonedMayonnaise ? sauce.value.seasonedMayonnaise--:'')),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_39, _hoisted_41))
                    ]),
                    _createTextVNode(" " + _toDisplayString(sauce.value.seasonedMayonnaise) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (sauce.value.seasonedMayonnaise++)),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_42, _hoisted_44))
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (sauce.value.ketchup || sauce.value.mayonnaise || sauce.value.seasonedMayonnaise ? notify('order_sauce'):'')),
                  class: _normalizeClass([sauce.value.ketchup || sauce.value.mayonnaise || sauce.value.seasonedMayonnaise ? 'bg-primary text-white' : 'bg-f5 text-94', "w-full p-4 py-2 mt-4 bg-red-300 text-white rounded-xl font-medium transition duration-200"])
                }, "solicitar", 2)
              ])
            ], 4)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["border rounded-xl p-4 flex flex-col transition-all duration-200", openSections.value.includes('utensils') ? 'gap-4':'gap-0'])
          }, [
            _createElementVNode("button", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (toggleSection('utensils'))),
              class: "flex items-center justify-between w-full"
            }, [
              _createElementVNode("div", _hoisted_45, [
                (_openBlock(), _createElementBlock("svg", _hoisted_46, _hoisted_48)),
                _hoisted_49
              ]),
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "8",
                viewBox: "0 0 15 8",
                stroke: "none",
                class: _normalizeClass(["transform transition-transform duration-200", openSections.value.includes('utensils') ? 'rotate-180':'rotate-0'])
              }, _hoisted_51, 2))
            ]),
            _createElementVNode("div", {
              class: "grid transition-all duration-200",
              style: _normalizeStyle({gridTemplateRows: openSections.value.includes('utensils') ? '1fr' : '0fr'})
            }, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_55, _hoisted_57)),
                    _hoisted_58
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (utensils.value.fork ? utensils.value.fork--:'')),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_60, _hoisted_62))
                    ]),
                    _createTextVNode(" " + _toDisplayString(utensils.value.fork) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (utensils.value.fork++)),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_63, _hoisted_65))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_68, _hoisted_70)),
                    _hoisted_71
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("button", {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (utensils.value.spoon ? utensils.value.spoon--:'')),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_73, _hoisted_75))
                    ]),
                    _createTextVNode(" " + _toDisplayString(utensils.value.spoon) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (utensils.value.spoon++)),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_76, _hoisted_78))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_81, _hoisted_83)),
                    _hoisted_84
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("button", {
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (utensils.value.knife ? utensils.value.knife--:'')),
                      class: "transition duration-200 hover:text-green-500 hover:fill-secondary"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_86, _hoisted_88))
                    ]),
                    _createTextVNode(" " + _toDisplayString(utensils.value.knife) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (utensils.value.knife++)),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_89, _hoisted_91))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_94, _hoisted_96)),
                    _hoisted_97
                  ]),
                  _createVNode(MySwitch, {
                    id: 'salt',
                    setChecked: (v) => utensils.value.salt = v
                  }, null, 8, ["setChecked"])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_100, _hoisted_102)),
                    _hoisted_103
                  ]),
                  _createVNode(MySwitch, {
                    id: 'napkin',
                    setChecked: (v) => utensils.value.napkin = v
                  }, null, 8, ["setChecked"])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_106, _hoisted_108)),
                    _hoisted_109
                  ]),
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("button", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (utensils.value.glass ? utensils.value.glass--:'')),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_111, _hoisted_113))
                    ]),
                    _createTextVNode(" " + _toDisplayString(utensils.value.glass) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (utensils.value.glass++)),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_114, _hoisted_116))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("div", _hoisted_118, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_119, _hoisted_121)),
                    _hoisted_122
                  ]),
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("button", {
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (utensils.value.plate ? utensils.value.plate--:'')),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_124, _hoisted_126))
                    ]),
                    _createTextVNode(" " + _toDisplayString(utensils.value.plate) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (utensils.value.plate++)),
                      class: "transition duration-200 hover:text-green-500"
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_127, _hoisted_129))
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (utensils.value.fork ||  utensils.value.spoon || utensils.value.knife || utensils.value.glass || utensils.value.plate  || utensils.value.salt || utensils.value.napkin ? notify('order_utensils'):'')),
                  class: _normalizeClass([utensils.value.fork ||  utensils.value.spoon || utensils.value.knife || utensils.value.glass || utensils.value.plate  || utensils.value.salt || utensils.value.napkin ? 'bg-primary text-white' : 'bg-f5 text-94', "w-full p-4 py-2 mt-4 bg-red-300 text-white rounded-xl font-medium transition duration-200"])
                }, "solicitar", 2)
              ])
            ], 4)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["border rounded-xl p-4 flex flex-col transition-all duration-200", openSections.value.includes('waiter') ? 'gap-4':'gap-0'])
          }, [
            _createElementVNode("button", {
              onClick: _cache[21] || (_cache[21] = ($event: any) => (toggleSection('waiter'))),
              class: "flex items-center justify-between w-full"
            }, [
              _createElementVNode("div", _hoisted_130, [
                (_openBlock(), _createElementBlock("svg", _hoisted_131, _hoisted_133)),
                _hoisted_134
              ]),
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "8",
                viewBox: "0 0 15 8",
                stroke: "none",
                class: _normalizeClass(["transform transition-transform duration-200", openSections.value.includes('waiter') ? 'rotate-180':'rotate-0'])
              }, _hoisted_136, 2))
            ]),
            _createElementVNode("div", {
              class: "grid transition-all duration-200",
              style: _normalizeStyle({gridTemplateRows: openSections.value.includes('waiter') ? '1fr' : '0fr'})
            }, [
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("button", {
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (notify('call_waiter'))),
                  class: "w-full p-4 py-2 mt-4 text-white rounded-xl font-medium transition duration-200 text-white bg-primary"
                }, "confirmar")
              ])
            ], 4)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["border p-4 flex flex-col rounded-xl transition-all duration-200", openSections.value.includes('bill') ? 'gap-4':'gap-0'])
          }, [
            _createElementVNode("button", {
              onClick: _cache[23] || (_cache[23] = ($event: any) => (toggleSection('bill'))),
              class: "flex items-center justify-between w-full"
            }, [
              _hoisted_138,
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "8",
                viewBox: "0 0 15 8",
                stroke: "none",
                class: _normalizeClass(["transform transition-transform duration-200", openSections.value.includes('bill') ? 'rotate-180':'rotate-0'])
              }, _hoisted_140, 2))
            ]),
            _createElementVNode("div", {
              class: "grid transition-all duration-200",
              style: _normalizeStyle({gridTemplateRows: openSections.value.includes('bill') ? '1fr' : '0fr'})
            }, [
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("button", {
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (selectedBillPaymentMethod.value = 'machine')),
                  class: "flex gap-4 items-center"
                }, [
                  _createElementVNode("div", {
                    style: {"background":"#f5f5f5"},
                    class: _normalizeClass(["p-3 rounded-full transition-border duration-200", selectedBillPaymentMethod.value == 'machine' ? 'border-2  border-primary':'border-2 border-transparent'])
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 13 23",
                      class: _normalizeClass(selectedBillPaymentMethod.value == 'machine' ? 'fill-primary' : '')
                    }, _hoisted_143, 2))
                  ], 2),
                  _createElementVNode("div", null, [
                    _createElementVNode("h6", {
                      class: _normalizeClass(["text-start transition-color duration-200 text-sm", selectedBillPaymentMethod.value == 'machine' ? 'text-primary font-semibold':''])
                    }, "Maquininha", 2),
                    _hoisted_144
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (selectedBillPaymentMethod.value = 'pix')),
                  class: "flex gap-4 items-center"
                }, [
                  _createElementVNode("div", {
                    style: {"background":"#f5f5f5"},
                    class: _normalizeClass(["p-3 rounded-full", selectedBillPaymentMethod.value == 'pix' ? 'border-2  border-primary':'border-2 border-transparent'])
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass([selectedBillPaymentMethod.value == 'pix' ? 'fill-primary' : '', "pix"]),
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "23",
                      height: "23",
                      viewBox: "0 0 23 23",
                      fill: "#949494"
                    }, _hoisted_147, 2))
                  ], 2),
                  _createElementVNode("div", null, [
                    _createElementVNode("h6", {
                      class: _normalizeClass(["text-start transition-color duration-200 text-sm", selectedBillPaymentMethod.value == 'pix' ? 'text-primary font-semibold':''])
                    }, "Pix", 2),
                    _hoisted_148
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (selectedBillPaymentMethod.value = 'online')),
                  class: "flex gap-4 items-center"
                }, [
                  _createElementVNode("div", {
                    style: {"background":"#f5f5f5"},
                    class: _normalizeClass(["p-3 rounded-full", selectedBillPaymentMethod.value == 'online' ? 'border-2  border-primary':'border-2 border-transparent'])
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "23",
                      height: "23",
                      viewBox: "0 0 18 22",
                      fill: "none",
                      stroke: selectedBillPaymentMethod.value == 'online' ? 'currentColor' : '#949494',
                      class: _normalizeClass([selectedBillPaymentMethod.value == 'online' ? 'text-primary' : '', "app"])
                    }, _hoisted_153, 10, _hoisted_149))
                  ], 2),
                  _createElementVNode("div", null, [
                    _createElementVNode("h6", {
                      class: _normalizeClass(["text-start transition-color duration-200 text-sm", selectedBillPaymentMethod.value == 'online' ? 'text-primary font-semibold':''])
                    }, "Pagar Online", 2),
                    _hoisted_154
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (selectedBillPaymentMethod.value = 'cash')),
                  class: "flex gap-4 items-center"
                }, [
                  _createElementVNode("div", {
                    style: {"background":"#f5f5f5"},
                    class: _normalizeClass(["p-3 rounded-full", selectedBillPaymentMethod.value == 'cash' ? 'border-2  border-primary':'border-2 border-transparent'])
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass([selectedBillPaymentMethod.value == 'cash' ? 'stroke-primary' : '', "money"]),
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      stroke: "#292f31",
                      fill: "none"
                    }, _hoisted_157, 2))
                  ], 2),
                  _createElementVNode("div", null, [
                    _createElementVNode("h6", {
                      class: _normalizeClass(["text-start transition-color duration-200 text-sm", selectedBillPaymentMethod.value == 'cash' ? 'text-primary font-semibold':''])
                    }, "Dinheiro", 2),
                    _hoisted_158
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (selectedBillPaymentMethod.value ? notify('order_bill'):'')),
                  class: _normalizeClass([selectedBillPaymentMethod.value ? 'bg-primary text-white' : 'bg-f5 text-94', "w-full p-4 py-2 mt-4 text-white rounded-xl font-medium transition duration-200"])
                }, "confirmar", 2)
              ])
            ], 4)
          ], 2)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "toggleModal"]))
}
}

})